import { SpeakerListState, SpeakersState } from './types';

export const emptySpeakerList: SpeakerListState = {
  ids: [],
  total: null,
  page: 0,
  loading: false,
};

export const initialState: SpeakersState = {
  speakersById: {},
  speakers: { ...emptySpeakerList },
  searchedSpeakers: { ...emptySpeakerList },
};
